import styled from 'styled-components';
import { Content } from './banner-content';

const FeatureMedia = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;
const FeatureSection = styled.section`
  display: flex;
  gap: var(--spacing-06);
  flex-direction: column;

  ${Content},
  ${FeatureMedia} {
    width: 100%;
    flex: 1;
  }
`;

type Section = typeof FeatureSection & {
  Content: typeof Content;
  Media: typeof FeatureMedia;
};

const Section: Section = FeatureSection as any;

Section.Content = Content;
Section.Media = FeatureMedia;

export { Section };
